import React, { useState, useEffect } from 'react';
import { CompanyStyles } from '../company/CompanyStyles';
import { MobileDrawer } from '../company/MobileDrawer';
import { DispatchModal } from '../company/DispatchModal';
import { DealsHeader } from './DealsHeader';
import { DealsHero } from './DealsHero';
import { LifecycleSection } from './LifecycleSection';
import { PracticesSection } from './PracticesSection';
import { DealsCTA } from './DealsCTA';
import { Footer } from '../landing/Footer';
import { BriefingModal } from '../landing/BriefingModal';

// Deals & Strategy subpage (route: /deals).
export default function DealsPage() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dispatchOpen, setDispatchOpen] = useState(false);
  const [dispatchContext, setDispatchContext] = useState('');

  const openBriefing = () => { setMobileOpen(false); setModalOpen(true); };
  const openDispatch = (context) => { setDispatchContext(context); setDispatchOpen(true); };

  useEffect(() => {
    document.title = 'Deals & Strategy | Frontier Deal OS™';
    if (!window.location.hash) window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.body.style.overflow = (mobileOpen || modalOpen || dispatchOpen) ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen, modalOpen, dispatchOpen]);

  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    let tries = 0;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      else if (tries++ < 20) setTimeout(tick, 100);
    };
    setTimeout(tick, 100);
  }, []);

  return (
    <div className="company-root min-h-screen bg-[#FBFBFB] text-stone-900 overflow-x-clip">
      <CompanyStyles />
      <DealsHeader onOpenBriefing={openBriefing} onOpenDispatch={openDispatch} onToggleMobile={() => setMobileOpen((v) => !v)} />
      <MobileDrawer open={mobileOpen} onClose={() => setMobileOpen(false)} onOpenBriefing={openBriefing} />

      <DealsHero />
      <LifecycleSection />
      <PracticesSection />
      <DealsCTA onOpenBriefing={openBriefing} />
      <Footer onOpenBriefing={openBriefing} />

      <BriefingModal isOpen={modalOpen} onClose={() => setModalOpen(false)} inquiryType="" />
      <DispatchModal open={dispatchOpen} onClose={() => setDispatchOpen(false)} context={dispatchContext} />
    </div>
  );
}
